import FooterSection from "assets/Footer";
import Navbar from "../assets/Navbar";
import CardDesign from "../components/cardDesign";
import useAllTrendingProducts from "hook/useAllTrendingProducts";
import { useState, useEffect } from "react";
import ShimmerFreeDelivery from "components/shimmer/ShimmerFreeDelivery";
import RevealOnScroll from "components/RevealOnScroll";
import { FaArrowLeft, FaArrowRight, FaStar, FaTag, FaTruck } from "react-icons/fa";
import ScrollToTopButton from "components/ScrollToTopButton";
const TrendingProductsFullPage = () => {
  const { allTrendingProducts, loading1, error } = useAllTrendingProducts();
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="bg-gray-100 flex flex-col min-h-[100dvh]">
      <Navbar />
      <main className="mx-auto w-full mb-4">
        <RevealOnScroll>
          <section className="relative overflow-hidden bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-500 p-5 text-white shadow-lg sm:px-10">
            <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-white/15 blur-2xl" />
            <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
            <div className="relative flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
              <div>
                {/* <p className="text-xs font-semibold uppercase tracking-widest text-white/90">
                  Trending Now
                </p> */}
                <h1 className="text-2xl font-extrabold sm:text-3xl">
                  Trending Products
                </h1>
                <p className="mt-2 max-w-xl text-sm text-white/90 sm:text-base">
                  Browse the most popular picks with ongoing deals and fast
                  delivery.
                </p>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                  <FaStar />
                  Trending Now
                </span>
                <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white text-slate-900 px-3 py-2">
                  <FaTag />
                  Most Popular
                </span>
              </div>
            </div>
          </section>
        </RevealOnScroll>
      </main>
      <div className="container mx-auto relative">
        {loading1 && <ShimmerFreeDelivery />}
        <CardDesign likeData={allTrendingProducts} />
      </div>
      <FooterSection />
      {showScrollTop && (
        <ScrollToTopButton />
      )}
    </div>
  );
};

export default TrendingProductsFullPage;
